export default __webpack_public_path__ + "static/media/Scenery09.87acd920.jpg";